import React from 'react';
import { useIsUser } from 'hooks';
import Header from '../header';
import styles from './main-layout.module.scss';

const MainLayout = ({ children }) => {
  const isUser = useIsUser();

  return (
    <div className={styles.layout}>
      <Header />
      <main>
        {isUser ? (
          <div className={styles.info}>
            Очередность отгрузки осуществляется с учетом формирования плана
            {' '}
            поездов со станции Ситница УП «Барановичское отделение Белорусской железной дороги»
          </div>
        ) : null}
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
